export const initialValues = {
         email: "",
         emailSecond: "",
         firstName: "",
         lastName: "",
         company: "",
         streetAddress: "",
         streetAddress2: "",
         streetAddress3: "",
         city: "",
         zip: "",
         country: "",
         phone: "",
         delivery: "",
         payment: "",
         termsConsent: false,
       };
